import React from 'react';
import SponsorPart from './components/SponsorPart';
import './Sponsors.scss';

const organizersImgs = [
  {
    src: 'imgs/logos/accenture.png',
    alt: 'Accenture',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://careers.accenture.com/sk-sk/Pages/index.aspx'
  },
  {
    src: 'imgs/logos/STU-FEI-zfv.png',
    alt: 'STU FEI',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.fei.stuba.sk/'
  }
];

const mediaPartnersImgs = [
  {
    src: 'imgs/logos/robimeit.png',
    alt: 'RobimeIT',
    imgWidthLarge: '200px',
    imgWidthDesktop: '200px',
    imgWidthTablet: '200px',
    imgWidthMobile: '200px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://robime.it/'
  },
  {
    src: 'imgs/logos/SME_logo.png',
    alt: 'SME',
    imgWidthLarge: '220px',
    imgWidthDesktop: '220px',
    imgWidthTablet: '220px',
    imgWidthMobile: '220px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.sme.sk/'
  }
];
// {
//   src: 'imgs/logos/touchit.png',
//   alt: 'TouchIt',
//   imgWidthLarge: '200px',
//   imgWidthDesktop: '200px',
//   imgWidthTablet: '200px',
//   imgWidthMobile: '200px',
//   classes: 'is-6-desktop is-full-mobile logo-margin',
//   url: 'https://touchit.sk/'
// },
// {
//   src: 'imgs/logos/NEXTECH.jpg',
//   alt: 'Nextech',
//   imgWidthLarge: '200px',
//   imgWidthDesktop: '200px',
//   imgWidthTablet: '200px',
//   imgWidthMobile: '200px',
//   classes: 'is-6-desktop is-full-mobile logo-margin',
//   url: 'https://www.pcrevue.sk/pc-revue'
// },
// {
//   src: 'imgs/logos/zive.jpg',
//   alt: 'Zive',
//   imgWidthLarge: '150px',
//   imgWidthDesktop: '150px',
//   imgWidthTablet: '150px',
//   imgWidthMobile: '150px',
//   classes: 'is-6-desktop is-full-mobile',
//   url: 'https://zive.aktuality.sk/'
// }
// ];

const platinumPartner = [
  {
    src: 'imgs/logos/redhat.png',
    alt: 'Red Hat',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    // classes: 'is-4-desktop is-full-mobile logo-margin',
    classes: 'is-full',
    url: 'https://www.redhat.com/en'
  }
];

const partnersImgs = [
  {
    src: 'imgs/logos/erste_digital.png',
    alt: 'ErsteDigital',
    imgWidthLarge: '230px',
    imgWidthDesktop: '230px',
    imgWidthTablet: '230px',
    imgWidthMobile: '230px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.erstedigital.com/en/home'
  },
  {
    src: 'imgs/logos/Siemens_Health.png',
    alt: 'Siemens',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.siemens-healthineers.com/sk/development-center'
  },
  {
    src: 'imgs/logos/cncf.svg',
    alt: 'Cloud Native Computing Foundation',
    imgWidthLarge: '360px',
    imgWidthDesktop: '360px',
    imgWidthTablet: '360px',
    imgWidthMobile: '360px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.cncf.io/'
  },
  {
    src: 'imgs/logos/ableneo_logo.png',
    alt: 'ableneo',
    imgWidthLarge: '260px',
    imgWidthDesktop: '260px',
    imgWidthTablet: '260px',
    imgWidthMobile: '260px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.ableneo.com/'
  }
];

const supportersImgs = [
  {
    src: 'imgs/logos/tuli.png',
    alt: 'Tuli',
    imgWidthLarge: '130px',
    imgWidthDesktop: '130px',
    imgWidthTablet: '130px',
    imgWidthMobile: '130px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://tuli.sk/'
  },
  {
    src: 'imgs/logos/Amazon_Web_Services_Logo.svg',
    alt: 'AWS',
    imgWidthLarge: '180px',
    imgWidthDesktop: '180px',
    imgWidthTablet: '180px',
    imgWidthMobile: '180px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://aws.amazon.com/'
  },
  {
    src: 'imgs/logos/Gendigital.png',
    alt: 'Gen',
    imgWidthLarge: '180px',
    imgWidthDesktop: '180px',
    imgWidthTablet: '180px',
    imgWidthMobile: '180px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.gendigital.com/'
  },
  {
    src: 'imgs/logos/envu.svg',
    alt: 'envu',
    imgWidthLarge: '220px',
    imgWidthDesktop: '220px',
    imgWidthTablet: '220px',
    imgWidthMobile: '220px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.envu.com/'
  }
];

const Sponsors = () => (
  <section className="section" id="sponsors">
    <SponsorPart imgs={organizersImgs} title="ORGANIZERS" />
    <SponsorPart imgs={platinumPartner} title="PLATINUM PARTNER" />
    <SponsorPart imgs={partnersImgs} title="PARTNERS" />
    <SponsorPart imgs={supportersImgs} title="SUPPORTERS" />
    <SponsorPart imgs={mediaPartnersImgs} title="MEDIA PARTNERS" />
  </section>
);

export default Sponsors;
